module.exports = __webpack_public_path__ + "static/media/circle-check.7b3f8785.png";